import './SectionCard.scss';
import cn from 'classnames';
import { PropsWithChildren, ReactElement, ReactNode } from 'react';
import { Background } from '@Components/designConstants';
import { WidgetContainer } from '@Components/WidgetContainer';
import { IconLabel } from './IconLabel';

interface SectionCardProps extends PropsWithChildren {
  icon: ReactElement;
  label: string;
  rightActions?: ReactNode;
  // The section's own root class, which scopes its stylesheet.
  className?: string;
}

// Chrome only: header, collapse and actions slot; each section supplies its own body. Nothing
// here may reference a particular section's data.
export const SectionCard = ({
  icon,
  label,
  rightActions,
  className,
  children
}: SectionCardProps) => (
  <WidgetContainer
    className={cn('onboarding-section-card', className)}
    background={Background.DARK}
    collapsible
    header={
      <IconLabel
        icon={icon}
        label={label}
        className='onboarding-section-card-title'
        labelClassName='onboarding-section-card-title-label'
      />
    }
    rightActions={rightActions}
  >
    {children}
  </WidgetContainer>
);
